module.exports = __webpack_public_path__ + "static/img/banner.5acee00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_6/banner.jpg
// module id = 0bfB
// module chunks = 0